import React, { useEffect, Suspense } from "react";
import { Box, Button, Typography } from "@mui/material";
import logo from "../assets/img/logo_with_text.png";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import LanguageSwitcher from "../components/LanguageSwitcher";
import useMediaQuery from "@mui/material/useMediaQuery";

const HomepageDeg = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const matches = useMediaQuery("(min-width:600px)");
  const handleAlert = (title, message, type) => {
    Swal.fire({
      title: title,
      icon: type,
      text: message,
    });
  };

  const location = useLocation();
  useEffect(() => {
    if (location.state?.success) {
      navigate(location.pathname, { success: false });
    }
  }, [location.state?.success, navigate]);

  const successMessage = location.state?.success;

  const handleSuccess = () => {
    handleAlert(
      t("Questionario inviato!"),
      t("La tua opinione è importante per noi, grazie!"),
      "success",
    );
  };
  const handleStart = (dip) => {
    window.location.href = "/questionariodeg?dip=" + dip;
  };

  return (
    <div style={{ marginLeft: "1.5rem", marginRight: "1.5rem" }}>
      <LanguageSwitcher />
      <Suspense fallback="loading">
        {successMessage && handleSuccess()}

        <Box
          sx={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <img
            src={logo}
            alt="Logo"
            style={{ width: 150, marginBottom: 30, marginTop: 70 }}
          />
          <Typography variant="h4" component="h1" align="center" mb={4}>
            {t(
              "Questionario di valutazione della qualità delle cure e dei servizi",
            )}
          </Typography>
          {t("testo-homepagedeg")
            .split("\n")
            .map((item, key) => {
              return (
                <Typography key={key} variant="p" component="p" align="center">
                  {" "}
                  {item}{" "}
                </Typography>
              );
            })}

          <Box
            sx={{
              display: "flex",
              flexDirection: matches ? "row" : "column",
              justifyContent: "space-evenly",
              width: "80%",
              alignItems: "center",
              mb: 5,
              mt: 5,
              gap: 2,
            }}
          >
            <Button
              variant="contained"
              size="large"
              onClick={() => handleStart("chir")}
              sx={{
                backgroundImage: "linear-gradient(135deg, #D89E61, #F98221)",
                fontWeight: "bold",
                height: 70,
                fontSize: 18,
                width: 290,
              }}
            >
              {t("Dip. Chirurgico")}
            </Button>
            <Button
              variant="contained"
              size="large"
              onClick={() => handleStart("ds")}
              sx={{
                backgroundImage: "linear-gradient(135deg, #D89E61, #F98221)",
                fontWeight: "bold",
                height: 70,
                fontSize: 18,
                width: 290,
              }}
            >
              {t("Day Surgery")}
            </Button>
            <Button
              variant="contained"
              size="large"
              onClick={() => handleStart("med")}
              sx={{
                backgroundImage: "linear-gradient(135deg, #D89E61, #F98221)",
                fontWeight: "bold",
                height: 70,
                fontSize: 18,
                width: 290,
              }}
            >
              {t("Dip. Medico")}
            </Button>
            <Button
              variant="contained"
              size="large"
              onClick={() => handleStart("riab")}
              sx={{
                backgroundImage: "linear-gradient(135deg, #D89E61, #F98221)",
                fontWeight: "bold",
                height: 70,
                fontSize: 18,
                width: 290,
              }}
            >
              {t("Dip. Medico - Riab. Estensiva")}
            </Button>
          </Box>

          <Typography
            variant="subtitle2"
            component="p"
            align="center"
            mt={4}
            fontStyle="italic"
            sx={{ fontSize: 16 }}
          >
            {t("testo-homepagedeg-privacy")}
          </Typography>
          <Typography
            variant="subtitle2"
            component="p"
            align="center"
            mt={1}
            fontStyle="italic"
          >
            {t("Grazie per la collaborazione.")}
          </Typography>

          <Box sx={{ marginTop: 10 }}>
            <Typography
              variant="body1"
              component="p"
              align="center"
              mt={4}
              pb={2}
              fontStyle="italic"
            >
              {t("La Sua Opinione ci aiuterà a rendere il servizio MIGLIORE")}
            </Typography>
          </Box>
        </Box>
      </Suspense>
    </div>
  );
};

export default HomepageDeg;
